import moment from "moment";
import { useState } from "react";

export const useTimeSelection = () => {
  const [currentMonth, setCurrentMonth] = useState(moment());
  const [selectedYear, setSelectedYear] = useState(moment().year());

  const nextMonth = () => {
    setCurrentMonth((prev) => {
      const next = prev.clone().add(1, "month");
      setSelectedYear(next.year());
      return next;
    });
  };

  const handleMonthYearChange = (date) => {
    if (date) {
      const selectedDate = moment(date);
      setCurrentMonth(selectedDate.startOf("month"));
      setSelectedYear(selectedDate.year());
    }
  };

  const prevMonth = () => {
    setCurrentMonth((prev) => {
      const prevDate = prev.clone().subtract(1, "month");
      setSelectedYear(prevDate.year());
      return prevDate;
    });
  };

  return {
    currentMonth,
    selectedYear,
    handleMonthYearChange,
    nextMonth,
    prevMonth,
  };
};
